import { Form as FormR } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import NavBar from "../NavBar/navbar";
import React, { useState, useContext, useEffect, useRef } from "react";
import { Table, Form, Input, Tooltip, Switch } from "antd";
import { Button } from "react-bootstrap";
import "./admin.css";
import Modal from "react-bootstrap/Modal";
import { canAccessPage, getTokenUser } from "../../helper/token";
import AxiosHelper from "../../helper/axios-helper";
import { useNavigate } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";

function Admin() {
  //#region State
  const navigate = useNavigate();
  const [users, setUsers] = useState();
  const [rolesModalVisible, setRolesModalVisible] = useState(false);
  const [selectedUserRoles, setSelectedUserRoles] = useState([]);
  const [tableSize] = useState("col-12");
  const [managePasswordModalShow, setManagePasswordModalShow] = useState(false);
  const [selectedManagePasswordUser, setSelectedManagePasswordUser] =
    useState("");
  const [cancelModalShow, setCancelModalShow] = useState(false);
  const [loggedInUser] = useState(getTokenUser());
  const [activeStatusFilters, setActiveStatusFilters] = useState([true]);

  //#endregion

  //#region Ant Table Column Definitions
  const UserColumns = [
    {
      title: "First Name",
      dataIndex: "first_name",
      render: (text, record, index) => {
        let isValid = true;

        if (record.first_name === "-") {
          isValid = false;
        }

        if (
          users.filter((user) => user.first_name === record.first_name).length >
          1
        ) {
          isValid = false;
        }
        return (
          <div
            style={{ minWidth: "150px", display: "flex", position: "relative" }}
          >
            {!isValid && (
              <Tooltip
                title="User name should be unique, and can't be '-'."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.first_name}
              onBlur={(e) => handleUserFirstNameChange(e, record)}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Surname",
      dataIndex: "surname",
      render: (text, record, index) => (
        <div>
          <FormR.Control
            className="editable-cell-input"
            size="sm"
            type="text"
            defaultValue={record.surname}
            onBlur={(e) => handleUserSurnameChange(e, record)}
          ></FormR.Control>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text, record, index) => {
        let isValid = true;

        if (record.email === "-") {
          isValid = false;
        }

        if (users.filter((user) => user.email === record.email).length > 1) {
          isValid = false;
        }
        return (
          <div
            style={{ minWidth: "150px", display: "flex", position: "relative" }}
          >
            {!isValid && (
              <Tooltip
                title="User email should be unique, and can't be '-'."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.email}
              onBlur={(e) => handleUserEmailChange(e, record)}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Password",
      width: "6vw",
      render: (text, record, index) => (
        <div>
          {record.user_type !== "client" && (
            <div>
              <Button
                size="sm"
                variant="primary"
                onClick={() => handleManagePasswordModalShow(record)}
              >
                Change
              </Button>
            </div>
          )}
          {record.user_type === "client" && (
            <div>
              <FormR.Control
                className="editable-cell-input"
                size="sm"
                type="text"
                defaultValue={record.password}
                onBlur={(e) => handleUserPasswordChange(e, record)}
              ></FormR.Control>
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Roles",
      dataIndex: "roles",
      width: "6vw",
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button size="sm" onClick={() => handleRolesButtonClick(record)}>
            View
          </Button>
        </div>
      ),
    },
    {
      title: "Active",
      dataIndex: "status",
      width: "8vw",
      filters: [
        { text: "Active", value: true },
        { text: "Inactive", value: false },
      ],
      filteredValue: activeStatusFilters,
      onFilter: (value, record) => record.status === value,
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{ color: filtered ? "blue" : "#000000", fontSize: "16px" }}
        />
      ),
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Switch
            checked={record.status}
            onChange={(checked) => handleActiveStatusChange(checked, record)}
          />
        </div>
      ),
    },
  ];
  //#endregion

  const handleActiveStatusChange = (checked, record) => {
    record.status = checked;
    handleSave(record);
    onTableDataChange(true);
  };

  //#region Local variables

  const EditableContext = React.createContext(null);

  const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };

  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
      if (editing) {
        inputRef.current.focus();
      }
    }, [editing]);
    const toggleEdit = () => {
      setEditing(!editing);
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    };
    const save = async () => {
      try {
        const values = await form.validateFields();
        toggleEdit();
        onTableDataChange(true);
        handleSave({
          ...record,
          ...values,
        });
      } catch (errInfo) {
        console.log("Save failed:", errInfo);
      }
    };
    let childNode = children;
    if (editable) {
      childNode = editing ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
    }
    return <td {...restProps}>{childNode}</td>;
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const userColumns = UserColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });
  //#endregion

  //#region Page load
  React.useEffect(() => {
    if (!canAccessPage("User Management")) {
      navigate("/login");
    }
    LoadPage();
  }, []);
  //#endregion

  //#region functions
  function GetNewRowKey(listItems) {
    if (listItems === undefined) {
      return 1;
    }
    if (listItems.length === 0) {
      return 1;
    }
    let biggestKey = 0;
    listItems.forEach((element) => {
      if (element.key > biggestKey) {
        biggestKey = element.key;
      }
    });
    biggestKey = biggestKey + 1;
    return biggestKey;
  }

  function LoadPage() {
    AxiosHelper.makeAxiosRequest("Read", "User", "GetUsers", null, null)
      .then((response) => {
        //add conversion to better data structure
        let convertedUsers = [];
        response.data.forEach((element) => {
          let convertedUser = {
            key: element.userId,
            first_name: element.firstName,
            surname: element.surname,
            email: element.email,
            password: element.password,
            user_type: "server",
            status: element.active,
          };
          convertedUsers.push(convertedUser);
        });

        setUsers(convertedUsers);
      })
      .catch((exception) => console.log(exception));
  }

  function onCancelChanges() {
    AxiosHelper.makeAxiosRequest("Read", "User", "GetUsers", null, null)
      .then((response) => {
        //add conversion to better data structure
        let convertedUsers = [];
        response.data.forEach((element) => {
          let convertedUser = {
            key: element.userId,
            first_name: element.firstName,
            //user_role: allRoles.find(o => o.id === element.roleID)==null?"None":allRoles.find(o => o.id === element.roleID).roleDescription,
            surname: element.surname,
            email: element.email,
            password: element.password,
            user_type: "server",
          };
          convertedUsers.push(convertedUser);
        });

        setUsers(convertedUsers);
      })
      .catch((exception) => console.log(exception));

    onTableDataChange(false);
    setCancelModalShow(false);
  }

  const handleRolesButtonClick = (record) => {

    if(record.user_type === "client"){
        setSelectedUserRoles([]);
        setRolesModalVisible(true);
        return;
    }

    AxiosHelper.makeAxiosRequest("Read", "User", "GetUserRoles",{userId:record.key},null)
    .then((response) => {
        const userRoles = [];
        response.data.forEach((role) => {
            userRoles.push({
                roleName: role.roleName,
                roleDescription: role.roleDescription,
            });
        })
        setSelectedUserRoles(userRoles);
        setRolesModalVisible(true);
    })
    .catch((error)=>{
        console.log(error);
    })
  };

  function handleAddUser() {
    onTableDataChange(true);
    let newKey = GetNewRowKey(users);
    const newData = {
      key: newKey,
      first_name: "-",
      surname: "-",
      email: "-",
      password: "-",
      user_type: "client",
      status: true,
    };
    const newUsers = [...users];
    newUsers.push(newData);
    setUsers(newUsers);
  }
  const handleCancelModalClose = () => setCancelModalShow(false);
  const handleCancelModalShow = () => setCancelModalShow(true);
  const handleManagePasswordModalClose = () =>
    setManagePasswordModalShow(false);
  function handleManagePasswordModalShow(selectedUser) {
    setSelectedManagePasswordUser(selectedUser);
    setManagePasswordModalShow(true);
  }


  function onManagePasswordSubmit(event) {
    event.preventDefault();

    let newPassword = event.target.Password.value;

    let tempuser = {
      UserId: selectedManagePasswordUser.key,
      FirstName: selectedManagePasswordUser.first_name,
      Surname: selectedManagePasswordUser.surname,
      Password: newPassword,
      Email: selectedManagePasswordUser.email,
      //RoleId:roles.find(o => o.roleDescription === selectedManagePasswordUser.user_role)==null?null:roles.find(o => o.roleDescription === selectedManagePasswordUser.user_role).roleId,
      Active: true,
    };

    AxiosHelper.makeAxiosRequest(
      "Create",
      "User",
      "UpdateUserPassword",
      { currentUserId: loggedInUser },
      tempuser
    )
      .then((response) => {
        notifySuccessful("Successfully updated user password.");
        console.log(response.data);
      })
      .catch((Error) => {
        notifyFailed(
          "Error while trying to update the user's password. Please try again."
        );
        console.log(Error);
      });
  }

  const notifyChanges = (message) => {
    toast.warning(message, {
      toastId: "ToastDataTableWarning",
      position: "top-right",
      autoClose: false,
      closeOnClick: true,
      draggable: false,
      progress: undefined,
      closeButton: true,
    });
  };

  function onTableDataChange(isDirty) {
    if (isDirty) {
      notifyChanges("Data table contains unsaved changes.");
    } else {
      toast.dismiss();
    }
  }

  const handleUserEmailChange = (e, row) => {
    //console.log(row);

    if (row.email !== e.target.value) {
      row.email = e.target.value;
      //console.log(row);
      handleSave(row);
      onTableDataChange(true);
    }
  };

  const handleUserSurnameChange = (e, row) => {
    //console.log(row);

    if (row.surname !== e.target.value) {
      row.surname = e.target.value;
      //console.log(row);
      handleSave(row);
      onTableDataChange(true);
    }
  };
  const handleUserPasswordChange = (e, row) => {
    //console.log(row);

    if (row.password !== e.target.value) {
      row.password = e.target.value;
      //console.log(row);
      handleSave(row);
      onTableDataChange(true);
    }
  };
  const handleUserFirstNameChange = (e, row) => {
    //console.log(row);

    if (row.first_name !== e.target.value) {
      row.first_name = e.target.value;
      //console.log(row);
      handleSave(row);
      onTableDataChange(true);
    }
  };

  const handleSave = (row) => {
    const newData = [...users];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    console.log(newData);
    setUsers(newData);
  };

  function hasDuplicates(arr, property) {
    const uniqueValues = new Set();

    for (const item of arr) {
      const value = item[property];

      if (uniqueValues.has(value)) {
        return true; // Found a duplicate
      } else {
        uniqueValues.add(value);
      }
    }

    return false; // No duplicates found
  }

  function SaveTable() {
    try {
      let tableValid = true;
      users.forEach((user) => {
        if (user.first_name === null || user.first_name === "-") {
          tableValid = false;
        }
      });

      console.log(hasDuplicates(users, "first_name"));
      if (hasDuplicates(users, "first_name") || hasDuplicates(users, "email")) {
        tableValid = false;
      }

      if (tableValid) {
        saveUsers(users);
        onTableDataChange(false);
        notifySuccessful("Saved Successfully.");
      } else {
        notifyFailed("Please make sure that all the users are correct.");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  }

  const notifySuccessful = (message) => {
    toast.success(message, {
      position: "bottom-center",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const notifyFailed = (message) => {
    toast.error(message, {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  function saveUsers() {
    try {
      let errorOccurred = false;
      let endpoint = "";
      let error = {};
      users.forEach((user) => {
        let tempuser = {
          UserId: user.key,
          FirstName: user.first_name,
          Surname: user.surname,
          Password: user.password,
          Email: user.email,
          //RoleId:roles.find(o => o.roleDescription === user.user_role)==null?null:roles.find(o => o.roleDescription === user.user_role).roleId,
          Active: user.status,
        };

        if (user.user_type === "server") {
          endpoint = "UpdateUser";
        } else {
          endpoint = "Register";
        }
        AxiosHelper.makeAxiosRequest(
          "Create",
          "User",
          endpoint,
          { currentUserId: loggedInUser },
          tempuser
        )
          .then((response) => {
            console.log("Register or update user response: " + response.data);
            LoadPage();
          })
          .catch((Error) => {
            if (Error === "ValidationError") {
              console.log(Error);
            }
            console.log(Error);
            errorOccurred = true;
          });
      });
      if (errorOccurred) {
        console.log(error);
        notifyFailed("An Error Occurred, Please Try Again.");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  }

  const handleRolesModalClose = () => {
    setRolesModalVisible(false);
  };

  const onChange = (page, filter, sorter) => {
    setActiveStatusFilters(filter.status);
  };

  //#endregion
  return (
    <div>
      {/* Manage Password Modal */}

      <Modal
        size="md"
        centered
        show={managePasswordModalShow}
        onHide={handleManagePasswordModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedManagePasswordUser.first_name} - Manage User Password
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div id="admin-password-modal">
            <div>
              <FormR onSubmit={onManagePasswordSubmit}>
                {/* <FormR.Group className="mb-3" controlId="formBasicUsername"> */}
                <FormR.Group className="mb-3">
                  <h2>User Password</h2>
                  <FormR.Control
                    id="Password"
                    placeholder="Password"
                    type="text"
                  />
                </FormR.Group>
                <FormR.Group id="admin-password-modal">
                  <Button
                    variant="success"
                    type="submit"
                    onClick={handleManagePasswordModalClose}
                  >
                    Submit
                  </Button>
                </FormR.Group>
              </FormR>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Confirm Cancel Modal */}

      <Modal centered show={cancelModalShow} onHide={handleCancelModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Clear Changes</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div>
              <p className="p-main">
                Are you sure you want to clear any changes made?
                <br />
                This does not include items that have been deleted.
              </p>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleCancelModalClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onCancelChanges}>
            Clear Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        centered
        show={rolesModalVisible}
        onHide={handleRolesModalClose}
      >
        <Modal.Header closeButton>
            <Modal.Title>User Roles</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Table
                columns={[
                    {
                    title: "Role Name",
                    dataIndex: "roleName",
                    key: "roleName",
                    },
                    {
                    title: "Role Description",
                    dataIndex: "roleDescription",
                    key : "roleDescription",
                    }
                ]}
                dataSource={selectedUserRoles} // Pass the roles data to this dataSource
            />
        </Modal.Body>
      </Modal>

      <ToastContainer />
      <NavBar />
      <div id="admin-body">
        <h1>Users</h1>
        <div className={tableSize}>
          <div id="admin-table-container">
            <Table
              pagination={{
                position: ["bottomCenter"],
                showSizeChanger: true,
                defaultPageSize: 20,
                hideOnSinglePage: false,
                pageSizeOptions: [5, 10, 20, 50, 100],
              }}
              onChange={onChange}
              bordered="true"
              components={components}
              columns={userColumns}
              dataSource={users}
              rowClassName="row-class-test"
              footer={() => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Button onClick={() => handleAddUser()}>Add User</Button>
                  <div style={{ display: "flex", gap: "20px" }}>
                    <Button
                      variant="danger"
                      onClick={handleCancelModalShow}
                      style={{ alignSelf: "right" }}
                    >
                      Clear Changes
                    </Button>
                    <Button
                      variant="success"
                      onClick={SaveTable}
                      style={{ alignSelf: "right" }}
                    >
                      Save Changes
                    </Button>
                  </div>
                </div>
              )}
            ></Table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Admin;
